import ApiClient from './api-client/api-client';

export default class BaseService {
    static async get(endpoint, queryParams = {}, config = {}, version = 'v1') {
        return ApiClient.get(endpoint, queryParams, config, version).then(
            response => response.data
        );
    }

    static async post(endpoint, body, queryParams = {}, config = {}, version = 'v1') {
        return ApiClient.post(endpoint, body, queryParams, config, version).then(
            response => response.data
        );
    }

    static async put(endpoint, body, queryParams = {}, version = 'v1') {
        return ApiClient.put(endpoint, body, queryParams, version).then(
            response => response.data
        );
    }

    static async patch(endpoint, body, queryParams = {}, version = 'v1') {
        return ApiClient.patch(endpoint, body, queryParams, version).then(
            response => response.data
        );
    }

    static async delete(endpoint, queryParams = {}, version = 'v1') {
        return ApiClient.delete(endpoint, queryParams, version).then(
            response => response.data
        );
    }

    static async postFile(endpoint, file, headers = {}, version = 'v1') {
        return ApiClient.postFile(endpoint, file, headers, version).then(
            response => response.data
        );
    }

    static async postFormData(endpoint, body, queryParams = {}, version = 'v1') {
        return ApiClient.postFormData(endpoint, body, queryParams, version).then(
            response => response.data
        );
    }
}
